import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { QuoteDetail, QuoteHeader } from '@quorum/models/xs-resource';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import { map, switchMap } from 'rxjs/operators';
import {
  QuoteLinesEntityActionTypes,
  CreateQuoteLineOnServer,
  CreateQuoteLineOnServerSuccess,
  GetQuoteLinesFromServer,
  GetQuoteLinesFromServerSuccess,
  UpdateQuoteLineOnServer,
  UpdateQuoteLineOnServerSuccess,
  UpdateDeclinedReasonForQuoteLineOnServer,
  UpdateDeclinedReasonForQuoteLineOnServerSuccess,
  UpdateDeclinedReasonForQuoteLineOnServerError,
  DeleteQuoteLineFromServer,
  DeleteQuoteLineFromServerSuccess,
  DeleteQuoteLineFromServerError,
  CreateQuoteLineOnServerError,
} from './quote-lines.actions';

@Injectable()
export class QuoteLinesEntityEffects {
  getSelectedQuoteLinesFromServer = createEffect(() =>
    this.dataPersistence.fetch(QuoteLinesEntityActionTypes.GetQuoteLinesFromServer, {
      run: (action: GetQuoteLinesFromServer, state: any) => {
        return this.apiService
          .get<QuoteDetail[]>(`v/1/fixed-operations/quote-details`, {
            params: action.payload,
          })
          .pipe(
            map((quoteLines) => {
              return new GetQuoteLinesFromServerSuccess(
                quoteLines.filter((quoteLine: QuoteDetail) => quoteLine.sourceType != 'DL')
              );
            })
          );
      },
      onError: (action: GetQuoteLinesFromServer, error) => {
        console.error('Error', error);
      },
    })
  );

  updateQuoteLineOnServer = createEffect(() =>
    this.dataPersistence.fetch(QuoteLinesEntityActionTypes.UpdateQuoteLineOnServer, {
      run: (action: UpdateQuoteLineOnServer, state: any) => {
        return this.apiService
          .put<QuoteDetail[]>(`v/1/fixed-operations/quote-details/${action.payload.id}`, action.payload)
          .pipe(
            map((quoteLine) => {
              return new UpdateQuoteLineOnServerSuccess(quoteLine);
            })
          );
      },
      onError: (action: UpdateQuoteLineOnServer, error) => {
        console.error('Error', error);
      },
    })
  );

  updateDeclinedReasonForQuoteLineOnServer = createEffect(() =>
    this.dataPersistence.fetch(QuoteLinesEntityActionTypes.UpdateDeclinedReasonForQuoteLineOnServer, {
      run: (action: UpdateDeclinedReasonForQuoteLineOnServer, state: any) => {
        return this.apiService
          .put<QuoteDetail[]>(`v/1/fixed-operations/quote-details/${action.payload.id}`, action.payload)
          .pipe(
            map((quoteLine: QuoteDetail) => {
              return new UpdateDeclinedReasonForQuoteLineOnServerSuccess(quoteLine);
            })
          );
      },
      onError: (action: UpdateDeclinedReasonForQuoteLineOnServer, error) => {
        console.error('Error', error);
        return new UpdateDeclinedReasonForQuoteLineOnServerError({
          message: 'Error updating declined quote line.',
          error: error,
        });
      },
    })
  );

  createQuoteLineOnServer = createEffect(() =>
    this.dataPersistence.fetch(QuoteLinesEntityActionTypes.CreateQuoteLineOnServer, {
      run: (action: CreateQuoteLineOnServer, state: any) => {
        let workFlowParams: any = {};
        if (action.payload.quoteLine.serviceGroupId != null) {
          workFlowParams.serviceGroupId = action.payload.quoteLine.serviceGroupId;
        }
        return this.apiService
          .get<any>(
            `v/1/fixed-operations/quote-headers/${action.payload.quoteLine.quoteHeaderId}/workflow/calculate-labour-rate/${action.payload.quoteLine.warrantySubmissionTypeId}`,
            {
              params: workFlowParams,
            }
          )
          .pipe(
            switchMap((labourRate: any) => {
              let caseDetails = JSON.parse(JSON.stringify(action.payload.quoteLine));
              caseDetails.transactionTypeId = labourRate.labourTransType;
              return this.apiService
                .post<QuoteDetail>(`v/1/fixed-operations/quote-details`, caseDetails, {
                  params: action.payload.queryParams,
                })
                .pipe(
                  map((quoteLine) => {
                    return new CreateQuoteLineOnServerSuccess({ quoteLine, previousValue: caseDetails });
                  })
                );
            })
          );

        // return this.apiService.post<QuoteDetail[]>(`v/1/fixed-operations/quote-details`, action.payload).pipe(
        //   map(quoteLine => {
        //     return new CreateQuoteLineOnServerSuccess(quoteLine);
        //   })
        // );
      },
      onError: (action: CreateQuoteLineOnServer, error) => {
        console.error('Error', error);
        return new CreateQuoteLineOnServerError({ quoteLine: action.payload.quoteLine, error: error });
      },
    })
  );

  deleteQuoteLineFromServer = createEffect(() =>
    this.dataPersistence.fetch(QuoteLinesEntityActionTypes.DeleteQuoteLineFromServer, {
      run: (action: DeleteQuoteLineFromServer, state: any) => {
        return this.apiService.delete<any>(`v/1/fixed-operations/quote-details/${action.payload.quoteLine.id}`).pipe(
          map((quoteLine: any) => {
            return new DeleteQuoteLineFromServerSuccess(action.payload.quoteLine);
          })
        );
      },
      onError: (action: DeleteQuoteLineFromServer, error) => {
        console.error('Error', error);
        return new DeleteQuoteLineFromServerError({ quoteLine: action.payload.quoteLine, error });
      },
    })
  );

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<any>,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {}
}
